module.exports = __webpack_public_path__ + "img/M854.e00ff246.jpg";